import { MenuItem } from "react-pro-sidebar";
import { styled } from "styled-components";

export const SidebarContainer = styled.div<{ $isMobileOpen?: boolean }>`
  /* width: 250px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.text};

  .ps-sidebar-root {
    border-right: none;
  }
  .ps-sidebar-container {
    background-color: transparent !important;
  }

  @media (max-width: 767px) {
    position: fixed;
    left: ${({ $isMobileOpen }) => ($isMobileOpen ? "0" : "-100%")};
    top: 0;
    transition: left 0.3s ease;
    width: 250px;
    z-index: 1100;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.subtle};
  text-decoration: none;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.text};
      background-color: transparent !important;
    }
  }

  &:first-of-type {
    height: 70px;
    margin-bottom: 2rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  /* font-size: 1em; */
  color: ${({ theme }) => theme.colors.text};
  margin-left: -18px;

  span {
    font-size: 1rem;
    font-weight: 400;
  }
`;

export const HeaderContent = styled.div<{ $isCollapsed: boolean }>`
  display: flex;
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "space-between"};
  align-items: center;
  padding: ${({ $isCollapsed }) => ($isCollapsed ? "0px" : "2rem 0px 0px")};
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
`;

export const CloseButton = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: block;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 20px;
  }
`;

export const DiscordButtonWrapper = styled.div<{ $isCollapsed: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${({ $isCollapsed }) => ($isCollapsed ? "0.5rem 0.1rem" : "1rem 0")};

  button {
    padding: ${({ $isCollapsed }) => $isCollapsed && " 0.3rem 0.9rem"};
  }
`;
